import awsConfig from "../aws-config";
import { fetchAuthSession } from "aws-amplify/auth";
import { resolveAuthToken } from "../utils/authToken";

const API_URL = awsConfig.api_url_create_business;

function extractAddressLines(address) {
  if (!address || typeof address !== "object") return [];
  const orderedFields = ["street", "line2", "city", "postcode", "country"];
  return orderedFields
    .map((field) => {
      const raw = address[field];
      if (!raw) return "";
      const trimmed = String(raw).trim();
      return trimmed.length ? trimmed : "";
    })
    .filter(Boolean);
}

export async function fetchBusiness() {
  try {
    const { tokens } = await fetchAuthSession();
    const authToken = resolveAuthToken(tokens);
    if (!authToken) throw new Error("No auth token");

    const res = await fetch(API_URL, {
      method: "GET",
      headers: { Authorization: `Bearer ${authToken}` },
    });

    if (!res.ok) {
      if (res.status === 404) return null;
      const message = await res.text().catch(() => "Failed to load business");
      throw new Error(message || "Failed to load business");
    }

    const data = await res.json();
    if (data?.businessAddress && !Array.isArray(data.businessAddressLines)) {
      const lines = extractAddressLines(data.businessAddress);
      data.businessAddressLines = lines;
      data.businessAddressFormatted = lines.join(", ");
    }
    return data;
  } catch (error) {
    console.error("fetchBusiness error:", error);
    return undefined;
  }
}
